import styled from "styled-components";

export const enum ESerpFeatureReportPresenceTabs {
    SERP_FEATURE_BREAKDOWN = "totalKeywordCounts",
    ME_AGAINST_SERP = "mainSiteKeywordCounts",
}

export const SerpFeatureReportPresenceWidgetWrapper = styled.div`
    padding: 0px 0 24px;
`;

export const SerpPresenceGraphTabsWrapper = styled.div`
    padding: 0 15px 15px 0;
`;

export const TooltipWrapper = styled.div`
    height: fit-content;
    width: "300px";
`;

export const ChartWrapper = styled.div`
    width: 100%;
`;
